(function () {
  var PX_PER_SEC = 30;

  // rAF-based marquee — no CSS animation, no glitch at loop point.
  // All tracks scroll left (negative X). "reverse" just means they
  // scroll in the opposite direction by starting from the midpoint.
  function startMarquee(track, reverse) {
    if (!track) return;

    var hw      = 0;   // half-width, measured after load
    var pos     = 0;   // offset in px, always 0..hw
    var last    = null;
    var dragging = false;
    var didDrag  = false;  // true if drag moved beyond threshold

    function measure() {
      // Round to whole pixel to keep the wrap exact and avoid sub-pixel snap.
      hw = Math.floor(track.scrollWidth / 2);
    }

    function tick(ts) {
      if (!dragging) {
        if (last !== null && hw > 0) {
          var delta = ((ts - last) / 1000) * PX_PER_SEC;
          pos = pos + delta;
          // Smooth wrap: subtract whole hw chunks instead of using modulo,
          // which keeps fractional precision and makes the loop seamless.
          while (pos >= hw) pos -= hw;
        }
        last = ts;
        // reverse: render from the other half so it appears to scroll the other way
        var x = reverse ? (pos - hw) : -pos;
        track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
      }
      requestAnimationFrame(tick);
    }

    // Re-measure when each image finishes loading (eager loads can complete
    // after `window.load` fires for cached vs uncached cases) and on resize.
    track.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', measure, { once: true });
    });
    window.addEventListener('resize', measure);

    // Drag
    var startX   = 0;
    var startPos = 0;
    var DRAG_THRESHOLD = 5; // px before we consider it a drag (not a click)

    function clientX(e) { return e.touches ? e.touches[0].clientX : e.clientX; }

    function onStart(e) {
      if (e.button !== undefined && e.button !== 0) return;
      measure();
      dragging  = true;
      didDrag   = false;
      startX    = clientX(e);
      startPos  = pos;
      track.classList.add('is-dragging');
      e.preventDefault();
    }

    function onMove(e) {
      if (!dragging || hw <= 0) return;
      var dx = clientX(e) - startX;
      if (Math.abs(dx) > DRAG_THRESHOLD) {
        didDrag = true;
      }
      // dragging left = increasing pos for forward, decreasing for reverse
      var newPos = startPos + (reverse ? dx : -dx);
      pos = ((newPos % hw) + hw) % hw;
      var x = reverse ? (pos - hw) : -pos;
      track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
      e.preventDefault();
    }

    function onEnd() {
      if (!dragging) return;
      dragging = false;
      last     = null;
      track.classList.remove('is-dragging');

      // If we actually dragged, suppress the next click on this track
      if (didDrag) {
        track.addEventListener('click', function suppressClick(e) {
          e.preventDefault();
          e.stopPropagation();
          track.removeEventListener('click', suppressClick, true);
        }, true);
      }
      didDrag = false;
    }

    track.addEventListener('mousedown',   onStart);
    track.addEventListener('touchstart',  onStart, { passive: false });
    document.addEventListener('mousemove',  onMove);
    document.addEventListener('touchmove',  onMove, { passive: false });
    document.addEventListener('mouseup',    onEnd);
    document.addEventListener('touchend',   onEnd);

    // Measure after fonts/images settle, then start
    window.addEventListener('load', function () {
      measure();
      requestAnimationFrame(tick);
    });
  }

  var tracks = [
    { sel: '.lookbook__track',              reverse: false },
    { sel: '.campaign__track',              reverse: true  },
    { sel: '.pdp__track',                   reverse: false },
    { sel: '.pdp-lower__track',             reverse: true  },
    { sel: '.pdp-related__track',           reverse: false },
    { sel: '[data-lc-track="grdt"]',        reverse: false },
    { sel: '[data-lc-track="restock"]',     reverse: true  },
    { sel: '[data-lc-track="reboot"]',      reverse: false },
    { sel: '[data-lc-track="home"]',        reverse: true  },
  ];

  // On mobile, skip tracks that render as static/scroll-snap layouts
  var isMobile = window.matchMedia('(max-width: 768px)').matches;
  var mobileSkip = [
    '.lookbook__track',
    '.campaign__track',
    '.pdp__track',
    '.pdp-lower__track',
    '.pdp-related__track'
  ];

  tracks.forEach(function (cfg) {
    if (isMobile && mobileSkip.indexOf(cfg.sel) !== -1) return;
    document.querySelectorAll(cfg.sel).forEach(function (track) {
      startMarquee(track, cfg.reverse);
    });
  });

})();
